<template>
  <v-dialog v-model="show" persistent max-width="400px">
    <v-card v-if="show">
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('player-close')" text icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-text>
        <v-row class="pl-5 mb-3 pt-4" no-gutters>
          <v-col md="12">
            <v-icon small>mdi-calendar-today</v-icon>{{ date | formatDateLong($i18n.locale) }}
          </v-col>
          <v-col md="12">
            <v-icon small>mdi-clock-outline</v-icon>{{ duration | formatTime }}
          </v-col>
          <v-col md="12" class="title text-truncate text-no-wrap">
            {{ clid }}
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col offset-md="1">
            <av-waveform v-if="src"
              :audio-src="src"
              :canv-width="300"
              :canv-height="80"
              :audio-controls="true">
            </av-waveform>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'voicemail-player',
  props: {
    clid: {
      type: String
    },
    date: {
      type: Number
    },
    duration: {
      type: Number
    },
    show: {
      type: Boolean,
      default: false
    },
    src: {
      type: String
    }
  }
}
</script>

<style>
audio:focus { outline: none }
</style>
